module.exports = __webpack_public_path__ + "static/media/Banquete-Cultural-2.731cf0de.jpg";